import {
  take, call, put,
} from 'redux-saga/effects'
import noop from 'lodash/noop'
import createNotifications from '@/helpers/notification'
import { selectSystem, setMode } from '@/store/actions/integrations'
import {
  INTEGRATION_DELETED,
  DELETE_INTEGRATION_ERROR,
  ERRORS_TO_ERROR_MESSAGES,
  KULON,
  ATM,
  BRIZ,
  MESH,
  UNILIGHT,
} from '@/constants/integrations'
import { deleteIntegrationsChannel } from './channels'
import messagesAliasCreator from '../notificationElements'
import { requestGetRootElements } from '@/store/actions/installation/getRootElemenet'
import { setTrueStatusGlobalFilter } from '@/store/actions/appSettings'

const MESSAGES_ALIASES = {
  [KULON]: messagesAliasCreator('АСУНО', 'КУЛОН'),
  [ATM]: messagesAliasCreator('АСУ', '1SIM'),
  [BRIZ]: messagesAliasCreator('АСУ', 'БРИЗ'),
  [MESH]: messagesAliasCreator('АСУ', 'МЭШ СЕТЬ'),
  [UNILIGHT]: messagesAliasCreator('АСУ', 'ЮНИЛАЙТ'),
}

function* deleteIntegrationSaga() {
  const toast = createNotifications()
  const channel = yield call(deleteIntegrationsChannel)

  while (true) {
    const eventData = yield take(channel)
    console.log('function*deleteIntegrationsSaga -> eventData', eventData);
    switch (eventData.status) {
      case 'ON_FAILED': {
        const errorNotifications = ERRORS_TO_ERROR_MESSAGES[eventData.errors[0].subject] || {}
        const messageConfig = MESSAGES_ALIASES[
          eventData.integrationType
        ][DELETE_INTEGRATION_ERROR] || noop
        toast(messageConfig(null, errorNotifications[eventData.errors[0].message] || `${eventData.description}`))
        break
      }
      case 'COMPLETED': {
        if (eventData.description === INTEGRATION_DELETED) {
          yield put(setTrueStatusGlobalFilter())
          yield put(selectSystem(null))
          yield put(setMode('CONNECTED_INTEGRATION'))
          yield put(requestGetRootElements())
          const messageConfig = MESSAGES_ALIASES[
            eventData.integrationType
          ][eventData.description] || noop
          toast(messageConfig(null))
        }
        break
      }
      default: break
    }
  }
}

export default deleteIntegrationSaga
